import React, { useEffect, useState } from 'react'
import startBtn from '../../img/parts/再生ボタン.png'
import event from '../../imports/timeline'
import video from '../../img/timeline/onoden.mp4'
import natumaturi_1 from '../../img/timeline/natumaturi/natumaturi_1.jpg'
import natumaturi_2 from '../../img/timeline/natumaturi/natumaturi_2.jpg'
import natumaturi_3 from '../../img/timeline/natumaturi/natumaturi_3.jpg'
import natumaturi_4 from '../../img/timeline/natumaturi/natumaturi_4.jpg'
import natumaturi_5 from '../../img/timeline/natumaturi/natumaturi_5.jpg'
import natumaturi_6 from '../../img/timeline/natumaturi/natumaturi_6.jpg'
import natumaturi_7 from '../../img/timeline/natumaturi/natumaturi_7.jpg'
import natumaturi_8 from '../../img/timeline/natumaturi/natumaturi_8.png'
import natumaturi_9 from '../../img/timeline/私物展示.png'

const tableData = event()

const Table = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [currentIndex2, setCurrentIndex2] = useState(0)
  const [loading, setLoading] = useState(true)

  const images = [
    natumaturi_1,
    natumaturi_2,
    natumaturi_3,
    natumaturi_4,
    natumaturi_5,
    natumaturi_6,
    natumaturi_7,
  ]
  const images2 = [natumaturi_8, natumaturi_9]

  useEffect(() => {
    // 1秒ごとに画像を切り替えるためのInterval
    const intervalId = setInterval(() => {
      // 次の画像のインデックスを計算
      const nextIndex = (currentIndex + 1) % images.length
      setCurrentIndex(nextIndex)
    }, 2000)

    // コンポーネントがアンマウントされたときにIntervalをクリア
    return () => clearInterval(intervalId)
  }, [currentIndex, images.length])

  useEffect(() => {
    // 1秒ごとに画像を切り替えるためのInterval
    const intervalId = setInterval(() => {
      // 次の画像のインデックスを計算
      const nextIndex = (currentIndex2 + 1) % images2.length
      setCurrentIndex2(nextIndex)
    }, 2000)

    // コンポーネントがアンマウントされたときにIntervalをクリア
    return () => clearInterval(intervalId)
  }, [currentIndex2, images2.length])

  useEffect(() => {
    // Twitterの埋め込みコードを動的に読み込む
    const script = document.createElement('script')
    script.src = 'https://platform.twitter.com/widgets.js'
    script.async = true
    document.head.appendChild(script)
    // コンポーネントがアンマウントされたときにスクリプトをクリーンアップ
    return () => {
      document.head.removeChild(script)
    }
  }, [])

  //ページを開いたらダウンロード
  const download = async () => {
    const imgArray: string[] = tableData
      .map((item) => item.img)
      .filter((img) => img !== undefined) as string[]
    try {
      await Promise.all(
        imgArray.map((url) => {
          return new Promise((resolve) => {
            const IllustBox = new Image()
            IllustBox.src = url
            IllustBox.onload = () => {
              resolve(null)
              setLoading(false)
            }
          })
        }),
      )
    } finally {
      // ロード完了後、ローディング状態を終了
      setLoading(false)
    }
  }
  useEffect(() => {
    download()
  }, [])

  return (
    <div className="relative flex items-start justify-center">
      {/* デスクトップ */}
      <table className="  hidden  w-3/4   bg-blue-900 xl:block">
        <thead>
          <tr className="sticky top-16  z-10 overscroll-contain  border-b bg-blue-900 text-center text-3xl text-white">
            <th className="px-4 py-2">2023</th>
            <th className="px-4 py-2">Event</th>
            <th className="px-4 py-2">▼ Click</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => (
            <>
              <tr
                className={`sticky top-16  z-10 overscroll-contain  border-b bg-blue-900 text-center text-3xl text-white `}
              >
                <th
                  className={`px-4 py-2  ${index === 65 ? 'block' : 'hidden'}`}
                >
                  2024
                </th>
              </tr>
              <tr
                key={index}
                className="bg-nemoBlue text-center text-2xl  text-white"
              >
                <td className="w-1/12  border-b py-4 shadow">{item.tl}</td>
                <td className="  border-b py-4 shadow">{item.event}</td>
                <td className="w-td border-b p-2 py-4 shadow  ">
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className=" flex transform items-center justify-center transition-transform duration-300 hover:scale-105"
                  >
                    {item.choice === 'Twitter' ? (
                      <blockquote className="twitter-tweet  ">
                        <a href={item.url}>
                          <div className="my-20 flex justify-center space-x-3 ">
                            <div className="h-2  w-2 animate-ping rounded-full bg-white"></div>
                            <div className="animation-delay-200  h-2 w-2 animate-ping rounded-full bg-white"></div>
                            <div className="animation-delay-400  h-2 w-2 animate-ping rounded-full bg-white"></div>
                          </div>
                        </a>
                      </blockquote>
                    ) : item.choice === 'Image' ? (
                      <div className="relative flex w-full items-center justify-center">
                        {loading ? (
                          <div className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform">
                            <div className="h-10 w-10 animate-spin rounded-full border-4 border-nemoBlue border-t-transparent"></div>
                          </div>
                        ) : (
                          <>
                            <img
                              src={item.img}
                              alt={`samune`}
                              className="mx-2 aspect-video w-4/5 rounded-xl object-contain"
                            />
                            <img
                              src={startBtn}
                              alt="start"
                              className="absolute inset-3/4 h-1/6"
                            />
                          </>
                        )}
                      </div>
                    ) : item.choice === 'Video' ? (
                      <video
                        width="100%"
                        height="100%"
                        controls
                        className=" mx-2  w-4/5 rounded-xl object-contain"
                      >
                        <source src={video} type="video/mp4" />
                      </video>
                    ) : item.choice === 'Change' ? (
                      <div className="flex w-full items-center justify-center">
                        <img
                          src={images[currentIndex]}
                          alt="changeImage"
                          className="mx-2 aspect-video w-4/5 rounded-xl object-contain"
                        />
                        <img
                          src={startBtn}
                          alt="start"
                          className="absolute inset-3/4 h-1/6"
                        />
                      </div>
                    ) : (
                      <div className="flex w-full items-center justify-center">
                        <img
                          src={images2[currentIndex2]}
                          alt="changeImage"
                          className="mx-2 aspect-video w-4/5 rounded-xl object-contain"
                        />
                        <img
                          src={startBtn}
                          alt="start"
                          className="absolute inset-3/4 h-1/6"
                        />
                      </div>
                    )}
                  </a>
                </td>
              </tr>
            </>
          ))}
          <tr>
            <td>　</td>
          </tr>
        </tbody>
      </table>

      {/* スマホ */}
      <table className="w-full bg-blue-900 xl:hidden">
        <thead>
          <tr className="sticky top-12 z-10 overscroll-contain  border-b bg-blue-900 text-center text-white">
            <th className="px-4 py-2">2023</th>
            <th className="px-4 py-2">Event ▼ Tap</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => (
            <>
              <tr
                className={`sticky top-12 z-10 overscroll-contain  border-b bg-blue-900 text-center text-white`}
              >
                <th
                  className={`px-4 py-2  ${index === 65 ? 'block' : 'hidden'}`}
                >
                  2024
                </th>
              </tr>
              <tr
                key={index}
                className="bg-nemoBlue text-center text-lg text-white "
              >
                <td className=" border-b py-1 shadow" rowSpan={2}>
                  {item.tl}
                </td>
                <td className="pb-1 pt-3 text-sm shadow">{item.event}</td>
              </tr>
              <tr>
                <td
                  className=" border-b bg-nemoBlue px-2 pb-2 shadow"
                  colSpan={2}
                >
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex transform items-center justify-center transition-transform duration-300 hover:scale-105"
                  >
                    {item.choice === 'Twitter' ? (
                      <blockquote className="twitter-tweet">
                        <a href={item.url}>
                          <div className="my-20 flex justify-center space-x-3">
                            <div className="h-2  w-2 animate-ping rounded-full bg-white"></div>
                            <div className="animation-delay-200  h-2 w-2 animate-ping rounded-full bg-white"></div>
                            <div className="animation-delay-400  h-2 w-2 animate-ping rounded-full bg-white"></div>
                          </div>
                        </a>
                      </blockquote>
                    ) : item.choice === 'Image' ? (
                      <div className="relative flex w-full items-center justify-center">
                        <img
                          src={item.img}
                          alt={`samune`}
                          className=" w-4/5 rounded-xl"
                        />
                        <img
                          src={startBtn}
                          alt="start"
                          className="absolute inset-3/4 h-1/6 "
                        />
                      </div>
                    ) : item.choice === 'Video' ? (
                      <video
                        width="100%"
                        height="100%"
                        controls
                        className=" m-4  w-4/5 rounded-xl object-contain"
                      >
                        <source src={video} type="video/mp4" />
                      </video>
                    ) : item.choice === 'Change' ? (
                      <div className="flex w-full items-center justify-center">
                        <img
                          src={images[currentIndex]}
                          alt="changeImage"
                          className="mx-2 aspect-video w-4/5 rounded-xl object-contain"
                        />
                        <img
                          src={startBtn}
                          alt="start"
                          className="absolute inset-3/4 h-1/6"
                        />
                      </div>
                    ) : (
                      <div className="flex w-full items-center justify-center">
                        <img
                          src={images2[currentIndex2]}
                          alt="changeImage"
                          className="mx-2 aspect-video w-4/5 rounded-xl object-contain"
                        />
                        <img
                          src={startBtn}
                          alt="start"
                          className="absolute inset-3/4 h-1/6"
                        />
                      </div>
                    )}
                  </a>
                </td>
              </tr>
            </>
          ))}
          <tr>
            <td>　</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default Table
